// NOTE: 正式な料金が確定するまでの仮データ。
// 現段階では価格数字は表示しない（カテゴリ名 + 「料金を見る」のみ）。
export const priceCategories = [
  {
    id: "hair-removal",
    en: "MEDICAL HAIR REMOVAL",
    jp: "医療脱毛",
    icon: "ri-sparkling-2-line",
  },
  {
    id: "slim-zero",
    en: "MEDICAL SLIM ZERO",
    jp: "医療痩身",
    icon: "ri-body-scan-line",
  },
  {
    id: "skin",
    en: "SKIN MANAGEMENT",
    jp: "お肌管理",
    icon: "ri-drop-line",
  },
  {
    id: "regenerative",
    en: "REGENERATIVE MEDICINE",
    jp: "再生医療",
    icon: "ri-seedling-line",
  },
  {
    id: "injectables",
    en: "INJECTABLES",
    jp: "注入治療",
    icon: "ri-syringe-line",
  },
  {
    id: "eye",
    en: "EYE TREATMENT",
    jp: "二重・目元",
    icon: "ri-eye-line",
  },
];